<div
  class="tag-pill"
  [style.backgroundColor]="color"
  [class.faded]="faded"
  [attr.title]="tooltip"
>
  <span class="tag-name">{{ name }}</span>

  <button
    *ngIf="showCross"
    type="button"
    aeroTooltip="{{ 'button_remove' | translate }}"
    class="remove-icon"
    (click)="onCrossClick($event)"
    aria-label="Remove tag"
  >
    <i class="fa fa-times"></i>
  </button>
</div>
